export const ALL_VARIETY_GROUP_ID = 'all';

const toId = (value) => (value === null || value === undefined ? '' : String(value));

export const normalizeVarietyGroups = (groups) => (
  (Array.isArray(groups) ? groups : [])
    .map((group) => ({
      id: group?.id,
      productId: group?.productId,
      name: String(group?.name || '').trim(),
      sortOrder: Number.isFinite(Number(group?.sortOrder)) ? Number(group.sortOrder) : 0,
      varietyIds: Array.from(new Set(
        (Array.isArray(group?.varietyIds) ? group.varietyIds : [])
          .map((id) => Number.parseInt(id, 10))
          .filter((id) => Number.isInteger(id))
      )),
    }))
    .filter((group) => group.id !== null && group.id !== undefined && group.name)
    .sort((a, b) => {
      const orderDiff = a.sortOrder - b.sortOrder;
      if (orderDiff !== 0) return orderDiff;
      return Number(a.id || 0) - Number(b.id || 0);
    })
);

export const getVarietyGroupTabs = (groups, allLabel = 'Todos') => {
  const normalized = normalizeVarietyGroups(groups);
  if (!normalized.length) return [];
  return [
    { id: ALL_VARIETY_GROUP_ID, label: allLabel },
    ...normalized.map((group) => ({
      id: toId(group.id),
      label: group.name,
      group,
    })),
  ];
};

export const resolveActiveVarietyGroupId = (activeGroupId, groups) => {
  const normalized = normalizeVarietyGroups(groups);
  if (!normalized.length) return ALL_VARIETY_GROUP_ID;
  const active = toId(activeGroupId || ALL_VARIETY_GROUP_ID);
  if (active === ALL_VARIETY_GROUP_ID) return ALL_VARIETY_GROUP_ID;
  return normalized.some((group) => toId(group.id) === active)
    ? active
    : ALL_VARIETY_GROUP_ID;
};

export const filterVarietiesByGroup = (varieties, groups, activeGroupId) => {
  const list = Array.isArray(varieties) ? varieties : [];
  const normalized = normalizeVarietyGroups(groups);
  const active = resolveActiveVarietyGroupId(activeGroupId, normalized);
  if (active === ALL_VARIETY_GROUP_ID || !normalized.length) return list;
  const group = normalized.find((entry) => toId(entry.id) === active);
  if (!group) return list;
  const visibleIds = new Set(group.varietyIds.map((id) => Number(id)));
  return list.filter((variety) => visibleIds.has(Number(variety?.id)));
};

export const mergeProductVarietyGroups = (product, groups) => ({
  ...product,
  VarietyGroups: normalizeVarietyGroups(groups),
});
